import { AuditServiceImpl } from "./audit-service";
import app from "../../sdAppModule";

app.service("auditService", AuditServiceImpl);
